// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__xn84l","login":"Layout_login__+jnVY"};